// extracted by mini-css-extract-plugin
module.exports = {"redPoint":"AccountIcon_redPoint__o__kh","addPointIcon":"AccountIcon_addPointIcon__mbbQD"};
module.exports.__checksum = "e40cfa7ac2bc"
